<template>
    <div>
        <v-dialog v-model="open" persistent max-width="400">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title >Eliminar planta</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pb-3 pt-6">
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text class="py-0">
                                <h2 class="pb-3" v-if="gateway">¿Deseas eliminar la planta {{ gateway.name }}?</h2 >
                                Una vez eliminada la planta no podra ser recuperado
                                <v-btn 
                                    @click="deletePlant"
                                    color="error"
                                    class="mt-9"
                                    block>
                                    Eliminar
                                </v-btn>
                                <v-btn 
                                    @click="close"
                                    color="primary"
                                    text
                                    class="mt-3"
                                    block>
                                    Cancelar
                                </v-btn>
                            </v-card-text>
                        </v-card>   
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'deleteGateway',
    props: ['open', 'id'],
    computed:{
        ...mapGetters({ 
            getGateway: 'gateways/getGateway',
            getMeters: 'meters/getMetersGtw'
        }),
    },
    data() {
        return {
            gateway: null
        }
    },
    methods: {
        ...mapActions({ 
            deleteGateway: 'gateways/deleteGateway',
            deleteMeters: 'meters/deleteMeters' 
        }),
        async deletePlant(){
            const meters = this.getMeters(this.id)
            try {
                await this.deleteMeters(meters)
                this.close()
                await this.deleteGateway(this.gateway)
            } catch (error) {
                console.log(error)
            }
        },
        close(){
            this.$emit('close')
        }
    },
    watch:{
        id(){
            if(this.id)
                this.gateway = this.getGateway(this.id)
        }
    }
}
</script>